// extracted by mini-css-extract-plugin
export default {"logout__container":"HdTR0","logout__dialog":"V3J22","logout__dialog-message":"_7uTD3"};